import * as firebase from 'firebase';

const settings = {timestampsInSnapshots: true};

const config = {
  apiKey: "AIzaSyDKhQAp3synfIJMi4MlSG-aM45-CsgFNOg",
  authDomain: "my-tutor-d4133.firebaseapp.com",
  databaseURL: "https://my-tutor-d4133.firebaseio.com",
  projectId: "my-tutor-d4133",
  storageBucket: "my-tutor-d4133.appspot.com",
  messagingSenderId: "636818248877",
};
const fire = firebase.initializeApp(config);

firebase.firestore().settings(settings);

export default fire;

